import { message } from "antd";
import uuidv1 from 'uuid/v1';
import axios from '../../util/axiosConfig';
import { GET_SITES_SUCCESS } from '../../constants/ActionTypes';

import { LOGIN_ERROR } from "../../constants/messages";
import { history } from '../store';
import { CLOSE_SESSION } from './integratorActions';
import { APP_MESSAGE_BROADCAST_CHANNEL } from '../../constants/constants';
import { GET_USER_SESSION_DATA } from './userLocalStorageSession';
import { getErrorMessage } from '../../util/ErrorUtils';
import { getUserAllowedRisWithMipsAPI, verifyOtpAPI } from '../../services/users-service';
import { activateQuillrUserAPI, renewQuillrSession, QUILLR_IFRAME_URL_KEY } from '../../services/quillr-service';
import { QUILLR_USER_ACTIVATED, fetchUsers } from './admin/usersActions';

export const activateQuillrUser = (userId) => async (dispatch, getState) => {
  if (userId == null || String(userId) === '0') throw new Error('Please select a saved user to activate.');
  const result = await activateQuillrUserAPI(userId);
  dispatch({ type: QUILLR_USER_ACTIVATED, userId });
  const current = getState().auth.authUser;
  if (current && String(current.userId) === String(userId)) {
    const user = { ...current, isScribeActivated: true };
    sessionStorage.setItem('user', JSON.stringify(user));
    dispatch({ type: USER_DATA, payload: user });
  }
  const { pagination } = getState().admin.users;
  dispatch(fetchUsers({ page: pagination.currentPage, size: pagination.pageSize }));
  return result;
};

export const AUTH_REFRESH = 'AUTH_REFRESH';
export const AUTH_REFRESH_START = 'AUTH_REFRESH_START';
export const AUTH_REFRESH_SUCCESS = 'AUTH_REFRESH_SUCCESS';
export const AUTH_REFRESH_ERROR = 'AUTH_REFRESH_ERROR';
export const HIDE_AUTH_REFRESH_ERROR = 'HIDE_AUTH_REFRESH_ERROR';

export const FETCH_USER = 'FETCH_USER';
export const FETCH_USER_START = 'FETCH_USER_START';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const FETCH_USER_ERROR = 'FETCH_USER_ERROR';

export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_START = 'SIGNIN_USER_START';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNIN_USER_ERROR = 'SIGNIN_USER_ERROR';
export const HIDE_SIGNIN_USER_ERROR = 'HIDE_SIGNIN_USER_ERROR';

export const VERIFY_OTP = "VERIFY_OTP";
export const VERIFY_OTP_START = "VERIFY_OTP_START";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_ERROR = "VERIFY_OTP_ERROR";

export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_START = 'SIGNOUT_USER_START';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const SIGNOUT_USER_ERROR = 'SIGNOUT_USER_ERROR';
export const HIDE_SIGNOUT_USER_ERROR = 'HIDE_SIGNOUT_USER_ERROR';

export const USER_DATA = 'user_data';
export const NEW_SESSION_CREATED = 'NEW_SESSION_CREATED';

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";

export const FETCH_USER_ALLOWED_RIS_WITH_MIPS = "FETCH_USER_ALLOWED_RIS_WITH_MIPS";
export const FETCH_USER_ALLOWED_RIS_WITH_MIPS_START = "FETCH_USER_ALLOWED_RIS_WITH_MIPS_START";
export const FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS = "FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS";
export const FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR = "FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR";

export const SET_SESSION_ROLE = "SET_SESSION_ROLE";
export const SET_SESSION_ROLE_START = "SET_SESSION_ROLE_START";
export const SET_SESSION_ROLE_SUCCESS = "SET_SESSION_ROLE_SUCCESS";
export const SET_SESSION_ROLE_ERROR = "SET_SESSION_ROLE_ERROR";

export const FETCH_USER_CONFIGURATIONS = "FETCH_USER_CONFIGURATIONS";
export const SET_DEFAULT_CONFIGURATIONS = "SET_DEFAULT_CONFIGURATIONS";
export const UPDATE_USER_CONFIGURATIONS = "UPDATE_USER_CONFIGURATIONS";
export const UPDATE_USER_CONFIGURATIONS_START = "UPDATE_USER_CONFIGURATIONS_START";
export const UPDATE_USER_CONFIGURATIONS_SUCCESS = "UPDATE_USER_CONFIGURATIONS_SUCCESS";
export const UPDATE_USER_CONFIGURATIONS_ERROR = "UPDATE_USER_CONFIGURATIONS_ERROR";

export const UPDATE_USER_OTP_VERIFICATION = "UPDATE_USER_OTP_VERIFICATION";
export const UPDATE_USER_IS_AUTHENTICATOR = "UPDATE_USER_IS_AUTHENTICATOR";

const initializeQuillrSession = async (user) => {
  const sessionId = sessionStorage.getItem('USESSIONID');
  try {
    sessionStorage.removeItem(QUILLR_IFRAME_URL_KEY);
    if (!user || user.isScribeUser !== true) return;
    await renewQuillrSession();
  } catch (error) {
    if (sessionStorage.getItem('USESSIONID') === sessionId) {
      message.error('Unable to start Clarity Scribe. You can continue using the report editor.');
    }
  }
};

export const userSignIn = (email, password) => {
  return (dispatch) => {
    dispatch({ type: SIGNIN_USER_START });
    axios.post('/api/auth/signin', {
      email: email,
      password: password,
    }
    ).then(({ data }) => {
      if (data) {
        // dispatch({ type: FETCH_USER_CONFIGURATIONS })
        const USESSIONID = uuidv1();
        const user = {
          ...data,
          created_at: new Date(),
          email_verified_at: null,
          role: data.roles.length === 1 ? data.roles[0] : null,
          updated_at: new Date(),
          authenticated: true,
          otpVerified: false,
        }
        sessionStorage.setItem("user", JSON.stringify(user));
        sessionStorage.setItem("USESSIONID", USESSIONID);
        sessionStorage.removeItem(QUILLR_IFRAME_URL_KEY);
        // dispatch({ type: SIGNIN_USER_SUCCESS });
        dispatch({ type: USER_DATA, payload: user });
        const channel = new BroadcastChannel(APP_MESSAGE_BROADCAST_CHANNEL);
        const obj = {
          action: NEW_SESSION_CREATED,
          payload: {
            sessionId: USESSIONID
          }
        }
        channel.postMessage(obj);
        history.push('/');
      } else {
        dispatch({ type: SIGNIN_USER_ERROR, payload: LOGIN_ERROR });
      }
    }).catch(function (error) {
      const errorMsg = getErrorMessage(error);
      if (errorMsg) {
        message.error(errorMsg);
        dispatch({ type: SIGNIN_USER_ERROR, payload: errorMsg });
      } else {
        dispatch({ type: SIGNIN_USER_ERROR, payload: LOGIN_ERROR });
      }
    });
  }
};

export const launchpadSignIn = (session) => {
  return (dispatch) => {
    dispatch({ type: SIGNIN_USER_START });
    axios.post('/api/auth/launchpad-signin', {
      session
    }).then(({ data }) => {
      if (data) {
        dispatch({ type: FETCH_USER_CONFIGURATIONS })
        const USESSIONID = uuidv1();
        const user = {
          ...data,
          created_at: new Date(),
          email_verified_at: null,
          role: data.roles.length === 1 ? data.roles[0] : null,
          updated_at: new Date(),
        }
        sessionStorage.setItem("user", JSON.stringify(user));
        sessionStorage.setItem("USESSIONID", USESSIONID);
        initializeQuillrSession(user);
        dispatch({ type: SIGNIN_USER_SUCCESS });
        dispatch({ type: USER_DATA, payload: user });
        const channel = new BroadcastChannel(APP_MESSAGE_BROADCAST_CHANNEL);
        const obj = {
          action: NEW_SESSION_CREATED,
          payload: {
            sessionId: USESSIONID
          }
        }
        channel.postMessage(obj);
        history.push('/');
      } else {
        dispatch({ type: SIGNIN_USER_ERROR, payload: LOGIN_ERROR });
      }
    }).catch(function (error) {
      const errorMsg = getErrorMessage(error);
      if (errorMsg) {
        dispatch({ type: SIGNIN_USER_ERROR, payload: errorMsg });
      } else {
        dispatch({ type: SIGNIN_USER_ERROR, payload: LOGIN_ERROR });
      }
      // history.push('/');
    });
  }
};

export const verifyOtp = (data) => {
  return async (dispatch, getState) => {
    dispatch({ type: VERIFY_OTP });
    const response = await verifyOtpAPI(data);
    if (response.success) {
      dispatch({ type: VERIFY_OTP_SUCCESS });
      initializeQuillrSession(getState().auth.authUser);
      history.push('/');
    } else {
      dispatch({ type: VERIFY_OTP_ERROR });
      message.error(response.error);
    }
  }
}

export const authRefresh = (appLoading) => {
  return (dispatch, getState) => {
    const { auth } = getState();
    if (appLoading) {
      dispatch({ type: AUTH_REFRESH_START });
    }
    axios.post('/api/auth/refresh')
      .then(({ data }) => {
        if (!auth.authUser) {
          dispatch(getUser());
        } else {
          dispatch({ type: AUTH_REFRESH_SUCCESS });
          dispatch({ type: GET_USER_SESSION_DATA, email: auth.authUser.email });
        }
        dispatch({ type: FETCH_USER_CONFIGURATIONS })
      }).catch(function (error) {
        dispatch(userSignOut());
        dispatch({ type: AUTH_REFRESH_ERROR });
      });
  }
};

export const getUser = () => {
  return (dispatch) => {
    dispatch({ type: FETCH_USER_START });
    axios.get('/api/v1/user/me')
      .then(({ data }) => {
        if (data) {
          const user = {
            ...data,
            created_at: new Date(),
            email_verified_at: null,
            role: data.roles.length === 1 ? data.roles[0] : null,
            updated_at: new Date(),
          }
          sessionStorage.setItem("user", JSON.stringify(user));
          dispatch({ type: FETCH_USER_SUCCESS });
          dispatch({ type: USER_DATA, payload: user });
          dispatch({ type: AUTH_REFRESH_SUCCESS });
        } else {
          dispatch(userSignOut());
          dispatch({ type: FETCH_USER_ERROR });
        }
      }).catch(function (error) {
        dispatch(userSignOut());
        dispatch({ type: FETCH_USER_ERROR });
      });
  }
};

export const userSignOut = () => {
  return (dispatch, getState) => {
    const { auth } = getState();
    dispatch({ type: SIGNOUT_USER_START });
    axios.post('/api/auth/signout')
      .then(({ data }) => {
        localStorage.removeItem("osimis_storage");
        sessionStorage.clear();
        if (auth && auth.authUser) {
          sessionStorage.removeItem(auth.authUser.email);
        }
        dispatch({ type: CLOSE_SESSION });
        dispatch({ type: SIGNOUT_USER_SUCCESS });
      }).catch(function (error) {
        sessionStorage.clear();
        dispatch({ type: SIGNOUT_USER_ERROR });
      });
  }
};

export const resetSignInError = () => {
  return (dispatch) => {
    dispatch({ type: HIDE_SIGNIN_USER_ERROR });
  }
}

export const resetReduxStore = () => {
  return (dispatch) => {
    dispatch({ type: SIGNOUT_USER_SUCCESS });
  }
}

export const changePassword = (user) => {
  return {
    type: CHANGE_PASSWORD,
    user
  };
};

export const updateSessionRole = (userId, role) => {
  return {
    type: SET_SESSION_ROLE,
    payload: {
      userId,
      role
    }
  };
}

export const fetchUserAllowedRisWithMips = (sessionRole) => {
  return async (dispatch) => {
    const response = await getUserAllowedRisWithMipsAPI(sessionRole);
    if (response.success) {
      dispatch({
        type: FETCH_USER_ALLOWED_RIS_WITH_MIPS_SUCCESS,
        risWithMips: response.risWithMips
      });
    } else {
      dispatch({
        type: FETCH_USER_ALLOWED_RIS_WITH_MIPS_ERROR
      })
    }
  }
}

export const updateUserConfigurations = (configurations, callback) => {
  return {
    type: UPDATE_USER_CONFIGURATIONS,
    payload: {
      configurations,
      callback
    }
  };
};

export const updateOtpVerificationStatus = () => {
  return (dispatch, getState) => {
    dispatch({ type: UPDATE_USER_OTP_VERIFICATION });
    initializeQuillrSession(getState().auth.authUser);
    dispatch({ type: FETCH_USER_CONFIGURATIONS });
  };
}

export const updateisAuthenticatorStatus = () => {
  return {
    type: UPDATE_USER_IS_AUTHENTICATOR,
  };
}
